/*
 * OpenAPI definition
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v0
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 3.0.58
 *
 * Do not edit the class manually.
 *
 */
import ApiClient from '../ApiClient';

/**
 * The AqaSubscriptionUpdateResponse model module.
 * @module model/AqaSubscriptionUpdateResponse
 * @version v0
 */
export default class AqaSubscriptionUpdateResponse {
  /**
   * Constructs a new <code>AqaSubscriptionUpdateResponse</code>.
   * @alias module:model/AqaSubscriptionUpdateResponse
   * @class
   */
  constructor() {
  }

  /**
   * Constructs a <code>AqaSubscriptionUpdateResponse</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/AqaSubscriptionUpdateResponse} obj Optional instance to populate.
   * @return {module:model/AqaSubscriptionUpdateResponse} The populated <code>AqaSubscriptionUpdateResponse</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new AqaSubscriptionUpdateResponse();
      if (data.hasOwnProperty('status'))
        obj.status = ApiClient.convertToType(data['status'], 'String');
      if (data.hasOwnProperty('message'))
        obj.message = ApiClient.convertToType(data['message'], 'String');
      if (data.hasOwnProperty('stripeSecret'))
        obj.stripeSecret = ApiClient.convertToType(data['stripeSecret'], 'String');
    }
    return obj;
  }
}

/**
 * @member {String} status
 */
AqaSubscriptionUpdateResponse.prototype.status = undefined;

/**
 * @member {String} message
 */
AqaSubscriptionUpdateResponse.prototype.message = undefined;

/**
 * @member {String} stripeSecret
 */
AqaSubscriptionUpdateResponse.prototype.stripeSecret = undefined;

